import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-unformat-upload',
  templateUrl: './unformat-upload.component.html',
  styleUrls: ['./unformat-upload.component.css']
})
export class UnformatUploadComponent implements OnInit {
  respObject: any;
  loaderVisibility: boolean = false;
  title = "";
  fileData="";

  fileYear="";
  filefYear
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  fileMonth="";
  fileQuarter="";

  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	this.title="";
  	this.fileMonth="";
    this.fileQuarter="";
    this.fileYear = "";
    this.filefYear = "";
  	
    for (var i= this.fullYear-4;i<=this.fullYear;i++){
      this.yearArr.push(i);
      //this.fileYear= i+"";
    }
    for (var i= this.fullYear-4;i<=this.fullYear;i++){
      this.yearfArr.push(i+"-"+(i+1));
      //this.filefYear = i+"-"+(i+1);
    }
  }
  uploadFile(){
  	const userId = localStorage.getItem('userId');
  	const companyId = localStorage.getItem('companyId');
  	const files = <HTMLInputElement>document.getElementById('file-multiple-input');
  	const fd = new FormData();
    fd.append('userId', userId);
    fd.append('companyId', companyId);
    var errCounter = 0;
    var errMsg = "";
    if(this.title==""){
    	errCounter++;
    	errMsg = "Please enter the title.";
    } else {
    	fd.append('title', this.title);
    }
    if (files.files[0]!= undefined) {
      fd.append('file', files.files[0]);
    } else {
      errCounter++;
      errMsg = "Please select valid excel file.";
    }
    if(this.fileMonth!=""){
    	fd.append('year', this.fileYear);
    	fd.append('quarter', '');
    	fd.append('month', this.fileMonth);
    	this.fileQuarter="";
    	this.filefYear="";
    } else {
    	this.fileYear="";
    	fd.append('year', this.filefYear);
    	fd.append('quarter', this.fileQuarter);
    	fd.append('month', '');
    }
    if(errCounter==0){
    	this._rest.otherFileUpload(fd).subscribe((res) => {
    		this.respObject = res;
    		if(this.respObject.error==0){
    			alert("File uploaded successfully.");
    			this.title="";
    			this.fileData="";
    		} else {
    			alert(this.respObject.errorMessage);
    		}
    	});
    } else {
    	alert(errMsg);
    }
  }

}
